import type { ReactNode } from 'react';
import { CheckCircleFillIcon, CloseCircleFillIcon, Col, Modal, Row, Tag, Text, TimeFilledIcon } from 'ui';
import { useEventRsvpLabels } from '../../hooks';

type P = {
  extra?: ReactNode;
  goingInviteesCount: number;
  notGoingInviteesCount: number;
  pendingInviteesCount: number;
};

const EventInviteesFooter = ({ extra, goingInviteesCount, notGoingInviteesCount, pendingInviteesCount }: P) => {
  const { getCountLabel } = useEventRsvpLabels();

  return (
    <Modal.ScrollableContent.Footer>
      <Row align="middle" justify="space-between">
        <Col>
          <Tag color="bg-none" icon={<CheckCircleFillIcon size="small" type="success" />}>
            <Text type="title" weight="medium">
              {getCountLabel({ count: goingInviteesCount, rsvp: 'going' })}
            </Text>
          </Tag>
          <Tag color="bg-none" icon={<TimeFilledIcon size="small" type="secondary" />}>
            <Text type="title" weight="medium">
              {getCountLabel({ count: pendingInviteesCount, rsvp: 'pending' })}
            </Text>
          </Tag>
          <Tag color="bg-none" icon={<CloseCircleFillIcon size="small" type="error" />}>
            <Text type="title" weight="medium">
              {getCountLabel({ count: notGoingInviteesCount, rsvp: 'not_going' })}
            </Text>
          </Tag>
        </Col>
        {extra ? <Col>{extra}</Col> : undefined}
      </Row>
    </Modal.ScrollableContent.Footer>
  );
};

export default EventInviteesFooter;
